export default __webpack_public_path__ + "static/media/aymen.d356a6c4.png";